export default __webpack_public_path__ + "static/media/remove.a6645436.svg";